
<script>
import Slider from './ui/Slider.vue'
import CountriesList from './ui/CountriesList.vue'
import NewsCarousel from './ui/NewsCarousel.vue'
import SubscriptionForm from './views/SubscriptionForm.vue'
import SearchForm from '@/components/views/searchForm/SearchForm.vue'

export default {
  name: 'Main',
  metaInfo: {
    title: 'Русский Экспресс - туроператор по Андорре, Болгарии, Израилю, Индии, Испании, Мальдивам, Мексике, ОАЭ, США, Таиланду, Финляндии, Франции, Чехии, Черногории, Хорватии'
  },
  components: {
    Slider,
    SearchForm,
    SubscriptionForm,
    CountriesList,
    NewsCarousel
  }
}
</script>

<template>
  <div class="main-page">
    <slider />
    <div class="app-content">
      <search-form
        :is-links-mode="false"
      />
    </div>
    <subscription-form />
    <news-carousel />
    <countries-list />
  </div>
</template>
